import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import useNavProps from '../../hooks/useNavProps';
import CompetitionToolbar from './CompetitionToolbar';
import CompetitionUtils from '../../utilities/CompetitionUtils';
import CompetitionWorkSeniorityComponent from '../../components/competition/CompetitionWorkSeniorityComponent';
import CompetitionRequirementComponent from '../../components/competition/CompetitionRequirementComponent';
import CompetitionEducationListComponent from '../../components/competition/CompetitionEducationListComponent';
import CompetitionTrainingReqComponent from '../../components/competition/CompetitionTrainingReqComponent';
import CompetitionItKnowledgeListComponent from '../../components/competition/CompetitionItKnowledgeListComponent';
import CompetitionLanguageListComponent from '../../components/competition/CompetitionLanguageListComponent';
import CompetitionJobApprovalComponent from '../../components/competition/CompetitionJobApprovalComponent';
import CompetitionOtherConditionComponent from '../../components/competition/CompetitionOtherConditionComponent';
import CompetitionBibliographyListComponent from '../../components/competition/CompetitionBibliographyListComponent';
import CompetitionWorkDurationComponent from '../../components/competition/CompetitionWorkDurationComponent';
import CompetitionJobDutyComponent from '../../components/competition/CompetitionJobDutyComponent';
import CompetitionOtherCompetencyListComponent from '../../components/competition/CompetitionOtherCompetencyListComponent';

const CompetitionRequirement = () => {
    const [competition, setCompetition] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    const { competitionIdParam } = useParams();

    const { setNavPropsValue } = useNavProps();

    useEffect(() => {
        setIsLoading(true);
        const getCompetition = async () => {
            await competitionService.getCompetition(competitionIdParam)
                .then(async (competitionData) => {
                    // console.log(competitionData);
                    setCompetition(competitionData);

                    setNavPropsValue('competition-job', competitionData.id, competitionData.name)

                    setIsLoading(false);
                })
                .catch((error) => toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getCompetition();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [competitionService, competitionIdParam]);

    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className="grid h-full">
                    <div className="col-12">
                        <div className="card h-full">
                            <CompetitionToolbar competition={competition} code="REQ" />

                            {CompetitionUtils.isJobCompetition(competition?.type) && <>
                                <div className='w-full grid pcn-data-view-panel'>
                                    <CompetitionRequirementComponent competition={competition} />
                                                                        
                                    <CompetitionWorkDurationComponent competition={competition} afterSave={(c) => setCompetition(c)} />

                                    <CompetitionJobDutyComponent competition={competition} afterSave={(c) => setCompetition(c)} />

                                    <CompetitionWorkSeniorityComponent competition={competition} afterSave={(c) => setCompetition(c)} />

                                    <CompetitionEducationListComponent competition={competition} />

                                    <CompetitionTrainingReqComponent competition={competition} afterSave={(c) => setCompetition(c)} />

                                    <CompetitionItKnowledgeListComponent competition={competition} />

                                    <CompetitionLanguageListComponent competition={competition} minorityLanguages={false}/>

                                    <CompetitionLanguageListComponent competition={competition} minorityLanguages={true}/>

                                    <CompetitionOtherCompetencyListComponent competition={competition} />

                                    <CompetitionJobApprovalComponent competition={competition}  afterSave={(c) => setCompetition(c)} />

                                    <CompetitionOtherConditionComponent competition={competition} afterSave={(c) => setCompetition(c)} />

                                    <CompetitionBibliographyListComponent competition={competition} />                                    
                                </div>
                            </>}
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default CompetitionRequirement;
